import React from "react";
import PropTypes from "prop-types";

/**
 * NodesWrapper
 *  - Wrapper for GroupE Nodes
 */
export function NodesWrapper(props) {
  const style = { borderColor: props.color };
  return (
    <div className={props.className} style={style}>
      {props.children}
    </div>
  );
}

NodesWrapper.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Theme color for group
   */
  color: PropTypes.string,
  /**
   *  Child components to render in Step
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

NodesWrapper.defaultProps = {
  className: "",
};
